// extracted by mini-css-extract-plugin
export default {"fondo":"loader_fondo__1zVET","loader":"loader_loader__HosFG","load1":"loader_load1__hqr4H"};